type SearchParamsLike = {
  get: (key: string) => string | null;
};

export type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_id?: string;
};

const getHashQueryParams = () => {
  if (typeof window === "undefined") {
    return new URLSearchParams();
  }

  const hash = window.location.hash || "";
  const queryStart = hash.indexOf("?");

  if (queryStart === -1) {
    return new URLSearchParams();
  }

  return new URLSearchParams(hash.slice(queryStart + 1));
};

export const getUtmParams = (searchParams: SearchParamsLike): UtmParams => {
  const hashParams = getHashQueryParams();

  return {
    utm_source:
      searchParams.get("utm_source") || hashParams.get("utm_source") || undefined,
    utm_medium:
      searchParams.get("utm_medium") || hashParams.get("utm_medium") || undefined,
    utm_campaign:
      searchParams.get("utm_campaign") || hashParams.get("utm_campaign") || undefined,
    utm_id: searchParams.get("utm_id") || hashParams.get("utm_id") || undefined,
  };
};
